<template>
  <div id="conteudo-atv">
    <div id="home">
      <HomeDestaques />

      <section
        id="parte-inferior"
        class="linha-home"
      >
        <!-- Lista de Notícias -->
        <NoticiasHome />

        <!-- Lista de Atividades -->
        <AtividadesHome />
      </section>
    </div>
  </div>
</template>

<script>
import userInfos from "@/utils/userInfos";
import HomeDestaques from "@/components/home/HomeDestaques.vue";
import NoticiasHome from "@/components/noticias/NoticiasHome.vue";
import AtividadesHome from "@/components/atividades/AtividadesHome.vue";

export default {
  name: "HomeView",
  components: {
    HomeDestaques,
    NoticiasHome,
    AtividadesHome,
  },

  data() {
    return {
      userName: null,
    };
  },

  mounted() {
    const user = userInfos.getUserInfos();
    this.userName = user?.sub ?? "";
  },
};
</script>

<style scoped>
#conteudo-atv {
  display: flex;
  flex-direction: column;
}

#home {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.linha-home {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 2.5rem;
}

@media (max-width: 768px) {
  #parte-inferior {
    flex-direction: column;
  }
}
</style>
